var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"text-align":"left !important"}},[_c('VueApexCharts',{ref:"vchart",attrs:{"type":_vm.type,"height":"295","options":_vm.chartOptions,"series":_vm.downloadedSeries}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }